import React from 'react';

import styled from '@tanium/react-emotion-9';
import { useThemeDefinition } from '@tanium/react-theme-definition';
import { useRandomId } from '@tanium/react-use-random-id';

import { opacityTransition } from '../../utils/transitions';
import { GuidelineShadowFloodColor, GuidelineStroke } from './themeDefinitions';

const Rect = styled('rect')({
  transition: opacityTransition,
});

export interface GuidelineProps {
  /**
   * The opacity of the guideline.
   */
  opacity: number;
  /**
   * The x-position of the guideline.
   */
  x: number;
  /**
   * The starting y-position of the guideline.
   */
  y1: number;
  /**
   * The ending y-position of the guideline.
   */
  y2: number;
}

export const Guideline = ({ opacity, x, y1, y2 }: GuidelineProps): JSX.Element => {
  const [stroke, floodColor] = useThemeDefinition([GuidelineStroke, GuidelineShadowFloodColor]);
  const hasShadow = floodColor !== undefined;

  const shadowId = `${useRandomId()}`;

  const width = 3;

  return (
    <>
      {hasShadow && (
        <defs>
          <filter id={shadowId} x="-400%" width="800%">
            <feDropShadow dx={0} dy={0} floodColor={floodColor} stdDeviation={3.5} />
          </filter>
        </defs>
      )}
      <Rect
        opacity={opacity}
        fill={stroke}
        width={width}
        height={y1 - y2}
        x={x - width / 2}
        y={y2}
        filter={hasShadow ? `url(#${shadowId})` : undefined}
      />
    </>
  );
};
